__turbopack_context__.v({
  "SContentWrapper": "GdGJdW_SContentWrapper",
  "noBgColor": "GdGJdW_noBgColor",
});
